import $ from 'domtastic'




/* UI TABS
----------------------------------------------------------------------------------------------------*/

export default class Tabs {

    constructor($el) {
        this.$els = {
            ctn  : $el,
            tabs : $el.find('.tab'),
        }

        this.pages = this.$els.tabs.map((t) => {
            const $tab = $(t)
            const ID = $tab.attr('href').split('#')[1]

            return {
                ID,
                $tab,
                $el: $(`#${ID}`),
            }
        })


        this.clickHandler = (e) => { this.onClick(e) }

        this.bindEvents()
    }


    bindEvents() {
        this.pages.forEach((p) => {
            p.$tab.on('click', (e) => {
                e.preventDefault()
                this.show(p)
            })
        })
    }




    /* Handlers
    --------------------------------------------------------- */

    onClick(e) {
        
    }




    /* Actions
    --------------------------------------------------------- */

    show({ ID }) {
        this.pages.forEach((p) => {
            p.$tab.toggleClass('is-selected', ID === p.ID)
            p.$el.toggleClass('is-selected', ID === p.ID)
        })
    }




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



